import { configure, extend, localize, setInteractionMode } from 'vee-validate';
import {
    confirmed,
    max,
    min,
    regex,
    required,
    email,
    numeric,
    double,
    max_value,
    min_value,
} from 'vee-validate/dist/rules';
import { customEager } from './vee-validate-modes';
import ru from 'vee-validate/dist/locale/ru.json';

extend('min', min);
extend('max', max);
extend('regex', regex);
extend('required', required);
extend('required-attribute-value', {
    validate(value) {
        if (!value || typeof value !== 'object') {
            return false;
        }

        const attributeValue = value.value;
        return attributeValue !== null && attributeValue !== undefined && String(attributeValue).trim().length > 0;
    },
    message: 'Значение атрибута обязательно для заполнения',
});
extend('confirmed', confirmed);
extend('email', email);
extend('numeric', numeric);
extend('double', double);
extend('max_value', max_value);
extend('min_value', min_value);

localize({
    ru: {
        ...ru,
        names: {
            'service': 'сервис',
            'category': 'категория',
            'executor': 'Исполнитель',
            'security-group': 'группа ответственных',
            'comment': 'комментарии',
            'resume-date': 'дата возобновления',
            'description': 'описание',
            'solution': 'Решение',
            'observers': 'Наблюдатели',

            // Инвентарь. Без этих имён сообщение выходило с техническим именем поля:
            // «Поле item-name обязательно для заполнения». Подписи — те же, что у полей.
            'item-name': 'Название',
            'item-cost': 'Цена',
            'item-delivered_at': 'Дата поставки',
            'item-warranty_expire_at': 'Срок завершения гарантии',
            'item-holder-kind': 'Ответственный',
            'item-city': 'Город',
            'item-responsible_person': 'Сотрудник',
            'item-holder': 'Запись справочника',
            'item-holder_expected_at': 'Владеет с (план)',
            'item-holder_until_at': 'Вернуть до',
            'type': 'Название справочника',
            'valueType': 'Тип значения',
            'attribute-value': 'Значение',
            'holder-full_name': 'ФИО',
            'holder-type': 'Вид',
            'holder-comment': 'Комментарий',
            'preset-preset_name': 'Название шаблона',
            'preset-preset_description': 'Описание шаблона',
            'preset-name': 'Название',
            'action-holder-kind': 'Кому',
            'action-holder': 'Получатель',
            'action-comment': 'Комментарий',
            'move-city': 'Куда',
            'move-comment': 'Комментарий',
            'return-comment': 'Комментарий',
            'repair-comment': 'Что случилось',
            'repair-return-comment': 'Комментарий',
            'mark-broken-comment': 'Что случилось',
            'clear-fault-comment': 'Комментарий',
            'write-off-comment': 'Причина списания',
        },
    },
});

configure({
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid',
    },
});

setInteractionMode('customEager', customEager);

localize('ru');
